// Match the results legend. Use the displayed whole percentage at boundaries.
export const resultColors = {
  terrible: '#FF1738',
  bad: '#F6AB2A',
  good: '#9ED06C',
  perfect: '#669635',
};

export const resultLegend = [
  { name: '0–80%', color: resultColors.terrible },
  { name: '81–90%', color: resultColors.bad },
  { name: '91–95%', color: resultColors.good },
  { name: '96–100%', color: resultColors.perfect },
];

export const getResultColor = (percentage) => {
  const displayed = Math.round(Number.isFinite(percentage) ? percentage : 0);
  if (displayed <= 80) return resultColors.terrible;
  if (displayed <= 90) return resultColors.bad;
  if (displayed <= 95) return resultColors.good;
  return resultColors.perfect;
};
